'use client'
import clsx from 'clsx'
import { MenuItemBlock, type MenuItemBlockProps } from '@/blocks/HeaderBlock/MenuItemBlock'
import { SecondaryNavigationLink } from '@/components/Header/NavigationLink/NavigationLink'
import { NavigationTriggerGeneralMenu } from '@/components/Header/NavigationTrigger/NavigationTriggerGeneralMenu'
import type { ExpectedBlockType, SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { filterByBlockType, getLinkFieldURL } from '@/services/storyblok/Storyblok.helpers'
import * as NavigationMenuPrimitive from '@radix-ui/react-navigation-menu'
import { storyblokEditable } from '@storyblok/react'
import {
  navigationContent,
  navigationItem,
  navigationItemGeneralMenu,
  navigationItemSubMenu,
  navigationMenuWrapper,
  navigationSecondaryItem,
  navigationSecondaryList,
} from '@/components/Header/Header.css'

export type GeneralMenuBlockProps = SbBaseBlockProps<{
  name: string
  menuItems: ExpectedBlockType<MenuItemBlockProps>
  currentActiveItem?: string
}>

export const GeneralMenuBlock = ({ blok }: GeneralMenuBlockProps) => {
  const filteredMenuItems = filterByBlockType(blok.menuItems, MenuItemBlock.blockName)

  if (filteredMenuItems.length === 0) {
    return null
  }

  return (
    <NavigationMenuPrimitive.Item
      className={clsx(navigationItem, navigationItemGeneralMenu, navigationItemSubMenu)}
      value={blok.name}
      {...storyblokEditable(blok)}
    >
      <NavigationTriggerGeneralMenu>{blok.name}</NavigationTriggerGeneralMenu>

      <NavigationMenuPrimitive.Content
        className={clsx(navigationContent, navigationMenuWrapper)}
        // Prevent closing the menu when cursor leaves content
        onPointerLeave={(event) => event.preventDefault()}
      >
        <ul className={navigationSecondaryList}>
          {filteredMenuItems.map((nestedBlock) => (
            <li
              key={nestedBlock._uid}
              className={navigationSecondaryItem}
              value={nestedBlock.name}
              {...storyblokEditable(nestedBlock)}
            >
              <SecondaryNavigationLink href={getLinkFieldURL(nestedBlock.link, nestedBlock.name)}>
                {nestedBlock.name}
              </SecondaryNavigationLink>
            </li>
          ))}
        </ul>
      </NavigationMenuPrimitive.Content>
    </NavigationMenuPrimitive.Item>
  )
}
GeneralMenuBlock.blockName = 'generalMenu'
